import React from "react";

export const ProfileContext = React.createContext({
  userName: "",
  setNewUsername: (newUserName: string, imageUrl: string) => { },
  userImg: "",
  isAdmin: Boolean(localStorage.getItem("isAdmin")),
  setIsAdmin: (isAdmin: boolean) => { },
  getProfileData: () => { }
});